import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Navigate } from "react-router-dom";

var msg = null;

export default function LogOut(){
    const dispatch = useDispatch()
    const setup = useSelector(state => state.site.setup);
    
    localStorage.clear();

return(
<Fragment>
{
    //dispatch({type:'SET_LOGED', payload:false})
}
<Navigate to={'/'+setup.lang}/>
</Fragment>
 )   


} 